import { useGetUserPositions } from "@/queries/users/users.api";
import { useEffect, useState } from "react";

const useUserPositionCatalog = (filterActiveOnly = false) => {
  const { data, isLoading, isFetching } = useGetUserPositions();

  const [position, setPosition] = useState<
    {
      label: string;
      value: string;
      active: boolean;
    }[]
  >([]);

  useEffect(() => {
    const rows = Array.isArray(data?.data) ? data.data : [];
    const filtered = filterActiveOnly
      ? rows.filter((r: { activo?: boolean }) => r.activo !== false)
      : rows;
    setPosition(
      filtered.map((r: { nombre: string; id: string; activo: boolean }) => {
        return {
          label: r.nombre,
          value: r.id,
          active: r.activo,
        };
      }),
    );
  }, [data, filterActiveOnly]);

  return {
    position,
    isLoading,
    isFetching,
  };
};

export default useUserPositionCatalog;
